var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineHeightLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487",
    transform: "translate(-9411.686 -2435.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498",
    "data-name": "Rectangle 498",
    width: 48,
    height: 3,
    rx: 1.5,
    transform: "translate(9411.686 2435.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_501",
    "data-name": "Rectangle 501",
    width: 48,
    height: 3,
    rx: 1.5,
    transform: "translate(9411.686 2454.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_504",
    "data-name": "Rectangle 504",
    width: 48,
    height: 3,
    rx: 1.5,
    transform: "translate(9411.686 2473.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineHeightLg);
export default __webpack_public_path__ + "static/media/line-height-lg.37237c9976eb86ad4708add039809541.svg";
export { ForwardRef as ReactComponent };